export default function AboutSection() {
  return (
    <section id="about" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-[800px] mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
              关于我们
            </h2>
            <p className="text-sm text-foreground-500">了解虫虫漫画的故事与初心</p>
          </div>

          <div className="bg-background-50 rounded-2xl p-6 md:p-8 border border-background-200/70">
            <div className="flex flex-col md:flex-row gap-6 md:gap-8 items-start">
              <div className="flex-shrink-0">
                <div className="w-16 h-16 md:w-20 md:h-20 rounded-2xl bg-primary-500 flex items-center justify-center">
                  <i className="ri-book-read-line text-background-50 text-2xl md:text-3xl"></i>
                </div>
              </div>

              <div className="flex-1">
                <div className="flex flex-wrap items-center gap-2 mb-4">
                  <span className="text-sm font-semibold px-2.5 py-1 rounded-full bg-primary-100 text-primary-700 whitespace-nowrap">免费阅读</span>
                  <span className="text-sm font-semibold px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 whitespace-nowrap">每日更新</span>
                  <span className="text-sm font-semibold px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap">韩日国漫</span>
                </div>

                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  虫虫漫画（曾用名汗汗虫虫漫画）成立于漫画阅读需求快速增长的年代。作为深耕漫画领域多年的在线阅读平台，
                  我们始终坚持以读者体验为核心，汇聚海量韩漫、日漫、国漫优质内容，打造无需注册、完全免费的漫画阅读空间。
                  从汗汗漫画到虫虫汗汗再到虫虫漫画，名称虽变，初心不改——让每一位漫画爱好者都能轻松找到并畅读自己喜欢的作品。
                </p>

                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  平台采用先进的下拉式阅读技术，读者无需频繁翻页即可沉浸式畅享长篇漫画。每日更新机制确保热门连载与源头同步，
                  三大品类全面覆盖满足不同读者的口味需求。虫虫漫画不仅是一个阅读工具，更是连接漫画创作者与爱好者的桥梁。
                </p>

                <div className="flex flex-wrap gap-4 md:gap-6 pt-2">
                  <div>
                    <span className="text-lg font-bold text-primary-600" style={{ fontFamily: 'var(--font-heading)' }}>10万+</span>
                    <span className="text-xs text-foreground-400 ml-1">收录作品</span>
                  </div>
                  <div>
                    <span className="text-lg font-bold text-accent-600" style={{ fontFamily: 'var(--font-heading)' }}>日更100+</span>
                    <span className="text-xs text-foreground-400 ml-1">更新话数</span>
                  </div>
                  <div>
                    <span className="text-lg font-bold text-primary-600" style={{ fontFamily: 'var(--font-heading)' }}>500万+</span>
                    <span className="text-xs text-foreground-400 ml-1">活跃读者</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}